module.exports = __webpack_public_path__ + "img/19.e3a778f0.jpg";